import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@/i18n";

const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  uz: "O'zbekcha",
  ru: "Русский",
  en: "English",
};

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  return (
    <select
      aria-label={t("common.language")}
      value={i18n.language}
      onChange={(event) => void i18n.changeLanguage(event.target.value)}
      className="w-full text-xs rounded-md border border-border bg-background px-2 py-1 text-muted-foreground"
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <option key={lang} value={lang}>
          {LANGUAGE_LABELS[lang]}
        </option>
      ))}
    </select>
  );
}
